/* eslint-disable react/require-default-props */

import React, { useEffect } from 'react';
import proptypes from 'prop-types';
import { params, QueryProvider, shape, string as stringType } from '@thd-nucleus/data-sources';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { HomeServicePhpCarousel } from './carousel/HomeServicePhpCarousel';

const { bool, string } = proptypes;

const PersonalizedHomeServices = ({ entryID = '', hideCarouselArrows = false, enableRoundedImages = false }) => {
  useEffect(() => {
    if (window.LIFE_CYCLE_EVENT_BUS?.lifeCycle?.trigger) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('personalized-home-services.ready');
    }
  }, []);

  return (
    <ImpressionProvider
      data={{
        id: entryID,
        component: 'PersonalizedHomeServices',
        name: 'PersonalizedHomeServices',
        type: 'content',
        position: 1,
      }}
    >
      <section className="sui-w-full sui-h-full" data-component="PersonalizedHomeServices">
        <div className="sui-h-full">
          <QueryProvider cacheKey="php-home-services">
            <HomeServicePhpCarousel hideCarouselArrows={hideCarouselArrows} enableRoundedImages={enableRoundedImages} />
          </QueryProvider>
        </div>
      </section>
    </ImpressionProvider>

  );
};

PersonalizedHomeServices.propTypes = {
  hideCarouselArrows: bool,
  entryID: string,
  enableRoundedImages: bool,
};

PersonalizedHomeServices.displayName = 'PersonalizedHomeServices';

PersonalizedHomeServices.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSource: stringType(),
    identifiers: shape({
      productLabel: stringType(),
    }),
  }),
};

export { PersonalizedHomeServices };
